import { FormSection as FormSectionType } from '../types/forms';
import { Field } from './fields/Field';
import { useApplicationStore } from '../store/application.store';

// Import the FieldValue type from a new file to avoid circular dependencies
import { FieldValue } from '../types/field-value';

interface FormSectionProps {
  section: FormSectionType;
}

// Purpose: Renders a section of the form with its fields and handles field value changes
export const FormSection: React.FC<FormSectionProps> = ({ section }) => {
  const { handleFieldValueChange } = useApplicationStore();

  if (!section) return null;

  return (
    <div className="mb-6 md:mb-8">
      {/* Section Layout */}
      <div className="flex flex-col lg:flex-row justify-start">
        {/* Left Column - Section Title and Description */}
        <div className="lg:w-64 flex-shrink-0">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">{section.title}</h3>
        </div>

        {/* Right Column - Form Fields */}
        <div className="flex-1 lg:pl-8 max-w-4xl">
          <div
            className={`grid gap-x-6 gap-y-3 md:gap-y-4 ${
              section.columns === 2 ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1'
            }`}
          >
            {section.fields.map((field) => (
              <div key={field.id} className="space-y-1">
                <Field
                  field={field}
                  onFieldChange={(value) => {
                    handleFieldValueChange(field.id, value as FieldValue);
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
